import Vue from 'vue'
const requireConText = require.context(
  './common',
  true,
  /\.vue$/
)
requireConText.keys().forEach(filename => {
  const componentConfig = requireConText(filename)
  Vue.component(
    componentConfig.default.name || componentConfig.name,
    componentConfig.default || componentConfig
  )
})
// 自定义指令引入
Vue.use((Vue) => {
  ((requireContext) => {
    const arr = requireContext.keys().map(requireContext);
    (arr || []).forEach((directive) => {
      directive = directive.__esModule && directive.default ? directive.default : directive;
      Object.keys(directive).forEach((key) => {
        Vue.directive(key, directive[key]);
      });
    });
  })(require.context('../directives', false, /^\.\/.*\.js$/));
});



// WEBPACK FOOTER //
// ./src/components/index.js